import { render, staticRenderFns } from "./DimensionSelect.vue?vue&type=template&id=33f48d82&scoped=true"
import script from "./DimensionSelect.vue?vue&type=script&lang=js"
export * from "./DimensionSelect.vue?vue&type=script&lang=js"
import style0 from "./DimensionSelect.vue?vue&type=style&index=0&id=33f48d82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f48d82",
  null
  
)

export default component.exports